// src/api/account.ts
import { api } from "../api";

/**
 * Delete the authenticated user's account.
 * Email users must provide their password for confirmation.
 * Google OAuth users only need a valid session.
 */
export const deleteAccount = async (password?: string) => {
  const res = await api.delete("/api/delete-account", {
    data: password ? { password } : undefined,
  });
  return res.data;
};
